import qs from 'qs'

export const parseURLParams = queryString => qs.parse(queryString, { arrayLimit: 50, ignoreQueryPrefix: true })

export const cleanURLParams = params => {
  const keys = Object.keys(params)
  // Reduce the key to a new object where the empty values ('', [], {}) get purged
  const newParams = keys.reduce((result, key) => {
    const value = params[key]
    const newResult = {
      ...result,
    }
    if (value) {
      newResult[key] = value
    }
    return newResult
  }, {})
  return newParams
}

export const stringifyURLParams = (params, opts = {}) =>
  qs.stringify(cleanURLParams(params), { encodeValuesOnly: true, arrayFormat: 'indices', ...opts })

export const removeTrailingSlash = url => (url.endsWith('/') ? url.slice(0, -1) : url)
